import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { FaceButton } from '@common/toolbox';

export interface UnregisteredSizeProps {
  children: React.ReactNode;
}

export function UnregisteredSize({ children }: UnregisteredSizeProps) {
  return <div>{children}</div>;
}

const Wrapper = styled.div`
  padding: 36px 0 0;
  text-align: center;
`;

const Title = styled.div`
  text-align: center;
`;

const Subtitle = styled.p`
  color: ${vars.v3Color.gray400};
  padding: 6px 0 20px 0;
  white-space: pre-wrap;
`;

const Button = styled(FaceButton)`
  padding: 0 20px;
`;

UnregisteredSize.Wrapper = Wrapper;
UnregisteredSize.Title = Title;
UnregisteredSize.Subtitle = Subtitle;
UnregisteredSize.Button = Button;
